import React from 'react';

export const LAST_STATE_KEY = 'path-report-state';

export type PathReportState = { scenario_id?: string; gas_date?: string };

/**
 * Read last selected state from localStorage.
 */
export function readLastState(): PathReportState | null {
  try {
    const raw = localStorage.getItem(LAST_STATE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/**
 * Persist selected state to localStorage.
 */
export function writeLastState(state: { scenario_id: string; gas_date: string }) {
  try {
    localStorage.setItem(LAST_STATE_KEY, JSON.stringify(state));
  } catch {
    // ignore
  }
}

// New: read state from URLSearchParams
export function readStateFromSearchParams(sp: URLSearchParams): PathReportState {
  const scenario_id = sp.get('scenario_id') || undefined;
  const gas_date = sp.get('gas_date') || undefined;
  return { scenario_id, gas_date };
}

// New: shared selection context for Path Report
export type PathReportSelection = { scenario_id?: string; gas_date?: string };
export const PathReportSelectionContext = React.createContext<{
  selected: PathReportSelection;
  setSelected: React.Dispatch<React.SetStateAction<PathReportSelection>>;
} | null>(null);

export function usePathReportSelection() {
  return React.useContext(PathReportSelectionContext);
}
